const middleware = {}

middleware['navigationGuard'] = require('../middleware/navigationGuard.js')
middleware['navigationGuard'] = middleware['navigationGuard'].default || middleware['navigationGuard']

export default middleware
